var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.251953,
    y: 0.121094,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#1859FF",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20942_287021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 9,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.25195,
    y: 4.12109,
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20942_287021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25228 10.4557C7.60228 10.4557 7.05095 10.2293 6.59828 9.7764C6.14539 9.32373 5.91895 8.7724 5.91895 8.1224C5.91895 7.4724 6.14539 6.92095 6.59828 6.46806C7.05095 6.0154 7.60228 5.78906 8.25228 5.78906C8.90228 5.78906 9.45361 6.0154 9.90628 6.46806C10.3592 6.92095 10.5856 7.4724 10.5856 8.1224C10.5856 8.7724 10.3592 9.32373 9.90628 9.7764C9.45361 10.2293 8.90228 10.4557 8.25228 10.4557Z",
    fill: "#1859FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldMapMarker);
export default __webpack_public_path__ + "static/media/WorldMap_Marker.7c890266f2471b8334e996e4c2d89c98.svg";
export { ForwardRef as ReactComponent };